export function moneyToFormString(
  raw: number | string | null | undefined,
): string {
  if (raw == null || raw === '') return ''
  const num = typeof raw === 'number' ? raw : Number(raw)
  if (!Number.isFinite(num)) return ''
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function moneyFormStringToApi(formatted: string): number | null {
  const cleaned = formatted.replace(/,/g, '').trim()
  if (!cleaned) return null
  const num = Number(cleaned)
  if (!Number.isFinite(num)) return null
  return Number(num.toFixed(2))
}

export function moneyToDisplay(
  raw: number | string | null | undefined,
): string {
  if (raw == null || raw === '') return '—'
  const num = typeof raw === 'number' ? raw : Number(raw)
  if (!Number.isFinite(num)) return '—'
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
